import React, { Suspense } from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import HomePage from "./pages/home";
import RulesPage from "./pages/rules";
import SettingPage from "./pages/settings";

import useDarkSide from "./hooks/useDarkSide";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import "./App.css";
import Loading from "./components/layout/Loading";
import MainLayout from "./components/layout/index";

function App() {
  useDarkSide();

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<Loading />}>
          <Router>
            <MainLayout>
              <Routes>
                <Route path="/" Component={HomePage} />
                <Route path="/rules" Component={RulesPage} />
                <Route path="/settings" Component={SettingPage} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </MainLayout>
          </Router>
        </Suspense>
      </PersistGate>
    </Provider>
  );
}

export default App;
